

import { BasicClientCommand } from "../BasicClientCommand";

export class PrivateOfferAcceptDialogClientCommand extends BasicClientCommand {
    public execute(commandVars: any = null): void {
        return;
    }
}

